export default __webpack_public_path__ + "static/buying-property-img-t-213926b20358bfb9dca654b52ab5962f.jpg";